import React from "react";
import { Skeleton } from "components/Skeleton";
import { useIsMobile } from "hooks";

import * as styles from "./MatchCardSkeleton.module.scss";

const MatchCardSkeleton = () => {
  const isMobile = useIsMobile();

  return (
    <Skeleton className={styles.matchCardSkeleton}>
      <div className={styles.header}>
        <div className={styles.icon} />

        <div className={styles.titleWrapper}>
          <Skeleton className={styles.title} mode="light" />
          <Skeleton className={styles.subtitle} mode="light" />
        </div>

        {isMobile && (
          <div className={styles.cluster}>
            <Skeleton className={styles.countdownClamp} mode="light" />
            <Skeleton className={styles.clamp} mode="light" />
          </div>
        )}
      </div>

      <div className={styles.outcomes}>
        <div className={styles.outcome}>
          <Skeleton
            shape="circle"
            mode="light"
            className={styles.outcomeIcon}
          />

          <div className={styles.nameAndOdds}>
            <Skeleton mode="light" className={styles.name} />
            <Skeleton mode="light" className={styles.odds} />
          </div>
        </div>

        <div className={styles.outcome}>
          <div className={styles.nameAndOdds}>
            <Skeleton mode="light" className={styles.name} />
            <Skeleton mode="light" className={styles.odds} />
          </div>
        </div>

        <div className={styles.outcome}>
          <Skeleton
            shape="circle"
            mode="light"
            className={styles.outcomeIcon}
          />

          <div className={styles.nameAndOdds}>
            <Skeleton mode="light" className={styles.name} />
            <Skeleton mode="light" className={styles.odds} />
          </div>
        </div>
      </div>

      {!isMobile && (
        <div className={styles.cluster}>
          <Skeleton className={styles.countdownClamp} mode="light" />
          <Skeleton className={styles.clamp} mode="light" />
        </div>
      )}
    </Skeleton>
  );
};

export { MatchCardSkeleton };
